<div class="modal-header">
  <h5 class="modal-title">Get Draft Link</h5>
  <button type="button" (click)="close()" aria-label="Close" class="close" [disabled]="isSaving">
    <span aria-hidden="true">
      <svg role="img">
        <use xlink:href="#icon-close"></use>
      </svg>
    </span>
  </button>
</div>

<div class="modal-body">
  <form [formGroup]="personForm" class="form-label-group mb-0">
    <!-- First Name -->
    <gs-input-material 
      label="First Name"
      name="firstname"
      placeholder="Enter first name"
      formControlName="firstname"
      [formControl]="personForm.controls.firstname"
      type="text">
    </gs-input-material>

    <!-- Last Name -->
    <gs-input-material
      label="Last Name"
      name="lastname"
      placeholder="Enter last name"
      formControlName="lastname"
      [formControl]="personForm.controls.lastname"
      type="text">
    </gs-input-material>

    <!-- Email -->
    <gs-input-material 
      label="Email"
      name="email"
      placeholder="Enter email"
      formControlName="email"
      [formControl]="personForm.controls.email"
      type="text">
    </gs-input-material>

    <!-- Error Handling -->
    <span *ngIf="isDuplicate" class="text-danger">This email already exists.</span>
  </form>

  <!-- Show API URL Result -->
  <div class="row" *ngIf="getDraftLink"> 
    <div class="col-6">
      <!-- <button  class="btns button_style"(click)="publicStory()"><span class="previousbutton">Story Page &nbsp;</span><i class="fa-thin fa-link"></i></button> -->
      <h6>Link is already Shared</h6>
      <p class="description_text">Copy the link </p>
    </div>
    <div class="col-6 text-center">
      <span class="previousbutton" (click)="copyLink()"><i class="fa-regular fa-link"></i></span>
    </div>
  </div>

<div class="modal-footer">
  <button type="button" [ngClass]="{'hide_cancel_btn':getDraftLink}" class="btn btn-outline btn-gray-light min-width" (click)="close()" [disabled]="isSaving">Cancel</button>
  <button type="button" class="btn btn-pink min-width" (click)="getDraftLink ? close() : getLink()" [disabled]="personForm.invalid || isSaving">
    {{getDraftLink ? 'Close' : (isSaving ? 'Saving…' : 'Save')}}
  </button>
</div>
